<template>
  <div>
    <Breadcrumbs main="shifts" title="active shifts" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-xl-12 xl-100">
          <b-card header-tag="div" no-body>
            <h5 slot="header">Active shifts</h5>
            <b-card-body>
              <b-tabs pills slot="header" class="tabbed-card">
                <b-tab title="3z" active>
                  <div class="row">
                  <div
                    class="col-sm-6"
                    v-for="shift in getActiveShifts"
                    :key="shift.id"
                    @click="changeView(shift.id)"
                  >
                    <px-card
                      class="bg-primary static-top-widget-card clickable"
                      v-if="getActiveShifts"
                    >
                      <div slot="with-padding">
                        <div class="media static-top-widget">
                          <div class="align-self-center text-center">
                            <feather type="navigation" class="middle"></feather>
                          </div>
                          <div class="media-body">
                            <span class="m-0">{{ shift.regPlate }}</span>
                            <h6 class="m-0">
                              {{ shift.shift }} <br />{{ shift.date }}
                            </h6>
                            <h4 class="mb-0 counter">{{ shift.fullName }}</h4>
                            <feather type="user" class="icon-bg"></feather>
                          </div>
                        </div>
                      </div>
                    </px-card>
                  </div>
                  </div>
                </b-tab>
                <b-tab title="Partner system">
                  <div class="row">
                  <div v-if="!getActivePartners.length">Currently there are no employees on this kind of shift. Please be add some.</div>
                  <div
                    class="col-sm-6"
                    v-for="shift in getActivePartners"
                    :key="shift.id"
                    @click="changeView(shift.id)"
                  >
                    <px-card
                      class="bg-secondary static-top-widget-card clickable"
                      v-if="getActivePartners"
                    >
                      <div slot="with-padding">
                        <div class="media static-top-widget">
                          <div class="align-self-center text-center">
                            <feather type="navigation" class="middle"></feather>
                          </div>
                          <div class="media-body">
                            <span class="m-0">{{ shift.regPlate }}</span>
                            <h6 class="m-0">
                              {{ shift.shift }} <br />{{ shift.date }}
                            </h6>
                            <h4 class="mb-0 counter">{{ shift.fullName }}</h4>
                            <h4 class="mb-0 counter">{{ shift.secondDriver }}</h4>
                            <feather type="user" class="icon-bg"></feather>
                          </div>
                        </div>
                      </div>
                    </px-card>
                  </div>
                  </div>
                </b-tab>
                <b-tab title="Solo system">
              <div class="row">
                  <div
                    class="col-sm-6"
                    v-for="shift in getActiveSolo"
                    :key="shift.id"
                    @click="changeView(shift.id)"
                  >
                    <px-card
                      class="bg-info static-top-widget-card clickable"
                      v-if="getActiveSolo"
                    >
                      <div slot="with-padding">
                        <div class="media static-top-widget">
                          <div class="align-self-center text-center">
                            <feather type="navigation" class="middle"></feather>
                          </div>
                          <div class="media-body">
                            <span class="m-0">{{ shift.regPlate }}</span>
                            <h6 class="m-0">
                              {{ shift.shift }} <br />{{ shift.date }}
                            </h6>
                            <h4 class="mb-0 counter">{{ shift.fullName }}</h4>
                            <feather type="user" class="icon-bg"></feather>
                          </div>
                        </div>
                      </div>
                    </px-card>
                  </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    this.fetchShifts();
  },
  computed: {
    getActiveShifts() {
      return !this.isLoading && this.$store.getters["shifts/getActive"].filter((item) => item.active && item.drivingSystem === "3Z");
    },
    getActiveSolo(){
      return !this.isLoading && this.$store.getters["shifts/getActive"].filter((item) => item.active && item.drivingSystem === "solo");
    },
    getActivePartners(){
      return !this.isLoading && this.$store.getters["shifts/getActive"].filter((item) => item.active && item.drivingSystem === "2Z");
    }
  },
  methods: {
    getImgUrl(path) {
      return require("@/assets/images/" + path);
    },
    async fetchShifts() {
      this.isLoading = true;
      await this.$store.dispatch("shifts/fetchShifts");
      await this.$store.dispatch("shifts/fetchActive")
      this.isLoading = false;
    },
    changeView(val) {
      this.$router.push(`/shifts/${val}`);
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
  width: 100%;
}
</style>
